// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@awc/XDL/Icons/Close";
import { buttonTransparent } from "@awc/XDL/PreStyle/button";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import color from "@awc/XDL/Utilities/color";
import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            size: fontConfig.fontSize.xSmall,
            weight: fontConfig.weight.bold,
            color: "common.white",
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: ${fontConfig.lineHeight.xSmall};
            `,
        },
        color: "common.ui8",
        iconProps: {
            src: Close,
            color: "common.ui1",
            width: 10,
            height: 10,
        },
        css: css`
            min-height: 25px;
            border-radius: 13px;
            align-items: flex-start;
            word-break: break-all;
            gap: 6px;
            padding: 4px 8px;
            margin: 0 8px 8px 0;
            button {
                margin: 0;
                flex-basis: unset;
                height: 17px;
                display: flex;
                align-items: center;
                ${buttonTransparent}
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui9")};
                    }
                }
                &:focus-visible:not([disabled]) {
                    outline: 1px solid ${color("common.white")};
                }
            }
        `,
    },
} as xBaseTheme["tag"];
